module.exports = __webpack_public_path__ + "img/translation.8fd91402.png";